export default __webpack_public_path__ + "static/media/bummer.304f5b3c.png";